import { WidgetButton } from "@fidget/common/components/widgetButton/widgetButton";
import React from "react";
import { UrlButton, Postback } from "../../../RichMessageTypes";
import styles from "./UrlButtonContent.css";
import { ButtonsStyleType } from "../ButtonContent";

interface Props {
  button: UrlButton;
  buttonsStyle: ButtonsStyleType;
  onLinkClicked?: (url: string, postback?: Postback) => void;
}

export const UrlButtonContent = ({ button, buttonsStyle, onLinkClicked }: Props) => {
  const handleClick = () => {
    window.open(button.url, "_blank");

    if (onLinkClicked) {
      onLinkClicked(button.url, button.postback);
    }
  };

  return (
    <WidgetButton
      onClick={handleClick}
      fullWidth={buttonsStyle === ButtonsStyleType.CAROUSEL}
      buttonStyle="secondary"
    >
      <span className={styles.text}>{button.displayText}</span>
    </WidgetButton>
  );
};
